// BookTickets/components/PresaleTestBanner/index.tsx
'use client'

import { useSyncExternalStore } from 'react'

import styles from './index.module.scss'

import { presaleNowOverride, presaleTestKey } from '@booking/lib/presale'
import { format as formatInLisbonTz } from '@booking/lib/date'

// The override is read from the URL on each render; there is nothing to subscribe to.
const subscribe = () => () => {}

/**
 * Marks a page whose time is simulated with ?now= (see lib/presale), so a test
 * link can't be mistaken for the real thing, and says whether the API gets the
 * simulated time too (&key=). Shown after hydration only, as the static HTML
 * can't see the query.
 */
export default function PresaleTestBanner() {
  const simulated = useSyncExternalStore(
    subscribe,
    () => presaleNowOverride()?.getTime() ?? null,
    () => null,
  )
  const withKey = useSyncExternalStore(subscribe, () => presaleTestKey() !== null, () => false)
  if (simulated === null) return null

  return (
    <div className={styles.banner} role="status" data-id="presale-test-banner">
      Modo de teste: hora simulada {formatInLisbonTz(simulated, 'dd/MM/yyyy HH:mm')} (Lisboa)
      {withKey
        ? ', enviada à API com a chave de teste'
        : ', só neste site: sem chave de teste, a API usa a hora real'}
    </div>
  )
}
